import { truncateText } from '../../utilities/helpers';
import { initWishlist, onClickWishlistonPues } from './towishlist';
import { updateScaledPrice } from './price';
import { updateInc } from './helper';

interface JumpToConfig {
    OffsetY?: number
}

export class Article {
  init() {
    // scroll to Product details
    const headerHeight = 80;
    const toggleDetails = document.querySelector('.pda-details-link');
    toggleDetails && toggleDetails.addEventListener('click', () => {
      event.preventDefault();
      const tabHeader = document.querySelector('.tab-header');
      const tab = document.querySelector('#tab1-tab');
      tabHeader && tabHeader.classList.remove('active');
      tab && tab.classList.add('active');
      tabHeader && document.querySelector('.tab-content').classList.remove('active');
      tabHeader && document.querySelector('#tab-content-description').classList.add('active');

      const productDetails = document.getElementById('product-details');

      const topOfElement = productDetails.getBoundingClientRect().top + window.pageYOffset - headerHeight;
      window.scroll({ top: topOfElement, behavior: 'smooth' });
    });

    initWishlist();

    const wishlistCta = document.querySelectorAll('.wishlist-cta');
    wishlistCta.forEach((cta: HTMLElement) => {
      cta.addEventListener('click', () => {
        onClickWishlistonPues(cta);
      });
    });

    const resultsScaledPrice = document.querySelector('.results-scaledprice');
    const pdaCtaBox = document.querySelector('.pda-cta-box');
    if (resultsScaledPrice) {
        if(document.querySelector('.pda.pda-v3') && document.querySelector('.best-prc-wrapper') ) {
            document.querySelector('.best-prc-wrapper').appendChild(resultsScaledPrice);
            (<HTMLElement>document.querySelector('.results-scaledprice')).style.maxHeight = (<HTMLElement>document.querySelector('.result-bulk')).offsetHeight + 'px';

            document.querySelector('.toggle-bestprice-table').addEventListener('click', function() {
                if(this.classList.contains('active')) {
                    this.classList.remove('active');
                    (<HTMLElement>document.querySelector('.results-scaledprice')).style.maxHeight = '0';
                } else {
                    this.classList.add('active');
                    (<HTMLElement>document.querySelector('.results-scaledprice')).style.maxHeight = (<HTMLElement>document.querySelector('.result-bulk')).offsetHeight + 'px';
                }

            });
        } else {
            pdaCtaBox.appendChild(resultsScaledPrice);
        }
    }

    // Truncate description & techdata
    if(document.querySelector('.pda.pda-v3')) {
          if(document.getElementById('techdata-wrap')) {
              truncateText(document.getElementById('techdata-wrap'));
          }
          if(document.getElementById('product-details')) {
              truncateText(document.getElementById('product-details'));
          }
    }

    // focus input if clicking anywhere on the incrementer box but the buttons
    const incrementerFields = document.querySelectorAll('.form-field-incremeter-field');
    if(typeof incrementerFields !== 'undefined') {
        incrementerFields.forEach(field => {
            field.addEventListener('click', () => {
                (field.querySelector('input[type="number"]') as HTMLInputElement).focus();
            });
        });
    }

    //add/subtract value on click
    const incs = document.querySelectorAll('.pda-cta-quantity .inc');
    incs.forEach(inc => {
        inc.addEventListener('click', () => {
            const quantityInput = inc.parentElement.querySelector('input');
            let newVal = parseInt(quantityInput.value);
            const max = quantityInput.getAttribute('max');

            if (inc.textContent === '+') {
                if (newVal < 1 || newVal === null || typeof newVal === 'undefined') {
                    newVal = 0
                }
                newVal = newVal + 1;
            } else {
                if (newVal < 1 || newVal === null || typeof newVal === 'undefined') {
                    newVal = 2
                }
                // Don't allow decrementing below 1
                if (newVal > 1) {
                    newVal = newVal - 1;
                } else {
                    newVal = 1;
                }
            }
            updateInc(newVal.toString(), max);
            updateScaledPrice(newVal.toString());
        });
    });

    const quantityInputs = document.querySelectorAll('.pda-cta-quantity .js-pda-quantity');
    quantityInputs.forEach((input: HTMLInputElement) => {
        input.addEventListener('input', () => {
            if (input.value === 'NaN' || input.value === '' || typeof input.value === 'undefined') {
                return;
            }
            let newVal = parseInt(input.value);
            const max = input.getAttribute('max');
            updateInc(newVal.toString(), max);
            updateScaledPrice(newVal.toString());
        });
    });

    // modal content on init
    const articleTitle = document.getElementById('article-title').innerHTML;
    const articleId = document.getElementById('article-id').getAttribute('data-article-id');
    const articlePrice = document.getElementById('article-price').innerHTML;
    const articleImage = document.querySelector('#pda-gallery-hero [data-article-id="' + articleId + '"] picture');
    let articleImageSource = '';
    articleImage && (articleImageSource = articleImage.innerHTML);

    const titles: Array<HTMLElement> = Array.from(document.querySelectorAll('.modal-product-title'));
    titles.forEach(el => el.innerHTML = articleTitle);
    const ids: Array<HTMLElement> = Array.from(document.querySelectorAll('.modal-product-id'));
    ids.forEach(el => el.innerHTML = articleId);
    const prices: Array<HTMLElement> = Array.from(document.querySelectorAll('.modal-product-price'));
    prices.forEach(el => el.innerHTML = articlePrice);
    const images: Array<HTMLElement> = Array.from(document.querySelectorAll('.modal-product-image'));
    articleImageSource && images.forEach(el => el.innerHTML = articleImageSource);

    // remove ti-parameter from url
    const loadedUrl = window.location.href;
    const displayUrl = this.removeURLParameter(loadedUrl, 'ti');

        window.history.replaceState("", "", displayUrl);

        const linkToProductDescription: HTMLElement | null = document.querySelector("#pda-anker-to-productdescription-section");

        if (linkToProductDescription) {
            linkToProductDescription.addEventListener('click', (event) => this.linkToProductDescriptionClickHandler(event));
        }
    }

    removeURLParameter(url: string, parameter: string) {
        var urlparts = url.split('?');
        if (urlparts.length >= 2) {

            var prefix = encodeURIComponent(parameter) + '=';
            var pars = urlparts[1].split(/[&;]/g);

            for (var i = pars.length; i-- > 0;) {
                if (pars[i].lastIndexOf(prefix, 0) !== -1) {
                    pars.splice(i, 1);
                }
            }

            return urlparts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
        }
        return url;
    }



    jumpToTarget(selector: string, options: JumpToConfig = {OffsetY: 0}) {
        const target = document.querySelector(selector);
        const headerBottom = document.querySelector("header").getBoundingClientRect().bottom

        if (!target) {
            console.warn("No target found.")
            return;
        }

        const targetPosition = target.getBoundingClientRect().top + window.scrollY - ((headerBottom > 0 ? headerBottom : 0) + options.OffsetY);

        window.scrollTo({
            top: targetPosition,
            behavior: "smooth"
        });
    }

    linkToProductDescriptionClickHandler(event: Event) {
        event.preventDefault();
        const options = { OffsetY: 30 };
        this.jumpToTarget('#pda-accordion-nav-product-description', options)
    }
}